import { toast } from 'react-toastify'
import {
    INTEGRATION_UPDATE_PUBLICATION_BEGIN,
    INTEGRATION_UPDATE_PUBLICATION_FAILURE,
    INTEGRATION_UPDATE_PUBLICATION_SUCCESS
} from '../constants'
import { BFFAgent } from 'BFFAgent'
import { MESSAGE } from '../../Constants'

export function updatePublication(body, isUpdateState) {
    return async (dispatch, getState) => {
        dispatch({
            type: INTEGRATION_UPDATE_PUBLICATION_BEGIN
        })

        const {carDataCatalogo: {publications}} = getState()
        try {
            const {data: responseData} = await BFFAgent.Integrations.updatePublication(body)
            if (responseData?.data[0] !== 1) { // el endpoint devuelve cantidad de registros modificados
                throw new Error('Error al actualizar publicación')
            }

            const currentPublications = publications.map(publication => {
                if (publication.id === body.publication.id) {
                    return {
                        ...publication,
                        state: body.publication.state,
                    }
                }
                return publication
            })
            dispatch({
                type: INTEGRATION_UPDATE_PUBLICATION_SUCCESS,
                data: currentPublications
            })
            toast.success(isUpdateState ? MESSAGE.UPDATE_STATE_SUCCESS : 'TODO: Agregar otra variable en constants')
        } catch (err) {
            dispatch({
                type: INTEGRATION_UPDATE_PUBLICATION_FAILURE
            })
            toast.error(isUpdateState ? MESSAGE.UPDATE_STATE_ERROR : 'TODO: Agregar otra variable en constants')
        }
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_UPDATE_PUBLICATION_BEGIN:
            return {
                ...state,
                publicationsPending: true
            }

        case INTEGRATION_UPDATE_PUBLICATION_SUCCESS:
            return {
                ...state,
                publicationsPending: false,
                publications: action.data
            }

        case INTEGRATION_UPDATE_PUBLICATION_FAILURE:
            return {
                ...state,
                publicationsPending: false
            }

        default:
            return state
    }
}
